import { UI } from "./ui.js";
export const CONSOLE_MESSAGE_PREFIX = "RAPTOR: ";
export const CONSOLE_EVENT_PREFIX = "RAPTOR-EVENT: ";
// Some sites will hijack the Console object, so we need to store a reference to the original one.
const _console = console;
export function isDebugModeEnabled() {
    return process.env.RAPTOR_DEBUG === "true";
}
export function beaconLog(message, ...optionalParams) {
    if (isDebugModeEnabled()) {
        UI.getInstance().log(message, optionalParams);
    }
    if (typeof message === "string") {
        _console.log(CONSOLE_MESSAGE_PREFIX + message, ...optionalParams);
    }
    else {
        _console.log(message, ...optionalParams);
    }
}
export function beaconWarn(message, ...optionalParams) {
    if (isDebugModeEnabled()) {
        try {
            throw new Error();
        }
        catch (e) {
            UI.getInstance().warn(message, [e, ...optionalParams]);
        }
    }
    if (typeof message === "string") {
        _console.error(CONSOLE_MESSAGE_PREFIX + "(warning) " + message, ...optionalParams);
    }
    else {
        _console.error(message, ...optionalParams);
    }
}
export function beaconError(message, ...optionalParams) {
    if (isDebugModeEnabled()) {
        UI.getInstance().error(message, optionalParams);
    }
    if (typeof message === "string") {
        _console.error(CONSOLE_MESSAGE_PREFIX + message, ...optionalParams);
    }
    else {
        _console.error(message, ...optionalParams);
    }
}
export function captureEvent(event) {
    if (isDebugModeEnabled()) {
        _console.log(CONSOLE_EVENT_PREFIX + JSON.stringify(event));
        UI.getInstance().displayEvent(event);
    }
}
export function captureFailedEvent(event, error) {
    if (isDebugModeEnabled()) {
        _console.error(CONSOLE_EVENT_PREFIX + JSON.stringify(event));
        UI.getInstance().displayFailedEvent(event, error);
    }
}
//# sourceMappingURL=testing.js.map